import React, { useCallback, useEffect, useState } from "react";
import moment from 'moment';

import GSTC from "gantt-schedule-timeline-calendar/dist/gstc.wasm.esm.min.js";
import { Plugin as TimelinePointer } from 'gantt-schedule-timeline-calendar/dist/plugins/timeline-pointer.esm.min.js';
import { Plugin as Selection } from 'gantt-schedule-timeline-calendar/dist/plugins/selection.esm.min.js';
import { Plugin as ItemMovement } from 'gantt-schedule-timeline-calendar/dist/plugins/item-movement.esm.min.js';
import { Plugin as ItemResizing } from 'gantt-schedule-timeline-calendar/dist/plugins/item-resizing.esm.min.js';
import { Plugin as CalendarScroll } from 'gantt-schedule-timeline-calendar/dist/plugins/calendar-scroll.esm.min.js';
import { Plugin as HighlightWeekends } from 'gantt-schedule-timeline-calendar/dist/plugins/highlight-weekends.esm.min.js';
import { Plugin as ProgressBar } from 'gantt-schedule-timeline-calendar/dist/plugins/progress-bar.esm.min.js';
import { Plugin as TimeBookmarks } from 'gantt-schedule-timeline-calendar/dist/plugins/time-bookmarks.esm.min.js';
import { Plugin as DependencyLines } from 'gantt-schedule-timeline-calendar/dist/plugins/dependency-lines.esm.min.js';
import { Plugin as ExportImage } from 'gantt-schedule-timeline-calendar/dist/plugins/export-image.esm.min.js';
import { Plugin as ExportPDF } from 'gantt-schedule-timeline-calendar/dist/plugins/export-pdf.esm.min.js';

import "gantt-schedule-timeline-calendar/dist/style.css";

import {
    Paper,
} from '@material-ui/core';

const REALIZADO_VENCIDO = "/static/images/map/alarme-1-green.gif";
const REALIZADO_EM_DIA = "/static/images/map/banner-1-green.png";
const EXECUTANDO_VENCIDO = "/static/images/map/alarme-1-yellow.gif";
const EXECUTANDO_EM_DIA = "/static/images/map/banner-1-yellow.png"
const SEM_ACAO_VENCIDO = "/static/images/map/alarme-1-red.gif";
const SEM_ACAO_EM_DIA = "/static/images/map/banner-1-red.png";
const SEM_OCORRENCIA = "/static/images/map/banner-1.png";

global.GSTC = GSTC;

const GSTCID = GSTC.api.GSTCID;
const iterations = 100;
const addDays = 30;

const isVencida = (ocorrencia) => {
    return moment(ocorrencia.cpa).isBefore(new Date()) || moment(ocorrencia.cpc).isBefore(new Date());
}

const getFileName = (ocorrencia) => {
    if (ocorrencia.rlz == 3) {
        if (isVencida(ocorrencia)) {
            return REALIZADO_VENCIDO;
        } else {
            return REALIZADO_EM_DIA;
        }
    } else if (ocorrencia.sxc || ocorrencia.hsv || ocorrencia.dca || ocorrencia.dia) {
        if (isVencida(ocorrencia)) {
            return EXECUTANDO_VENCIDO;
        } else {
            return EXECUTANDO_EM_DIA;
        }
    } else {
        if (isVencida(ocorrencia)) {
            return SEM_ACAO_VENCIDO;
        } else {
            return SEM_ACAO_EM_DIA;
        }
    }
}

function getDefaultImage(tecnico) {
    return `/static/images/avatars/user.svg`;
}

const colors = ['#E74C3C', '#DA3C78', '#7E349D', '#0077C0', '#07ABA0', '#0EAC51', '#F1892D'];
function getRandomColor() {
    return colors[Math.floor(Math.random() * colors.length)];
}

function getRowsItems(appointments) {
    /**
     * @type {import("../../dist/gstc").Rows}
     */
    const rows = {};
    for (let ccindex = 0; ccindex < appointments.length; ccindex++) {
        var cc = appointments[ccindex];
        const ccid = GSTCID(String(cc.id));
        rows[ccid] = {
            id: ccid,
            code: cc.codigo,
            name: cc.nome,
            parentId: undefined,
            expanded: true,
            desc: '',
            visible: true,
            element: cc
        };

        for (let index = 0; index < cc.ocorrencias.length; index++) {
            const oc = cc.ocorrencias[index];
            const ocid = GSTCID(String(oc.id));
            rows[ocid] = {
                id: ocid,
                code: '',
                name: ' OT: ' + oc.ot + ` ( ${oc.categoria} )`,
                parentId: ccid,
                expanded: true,
                img: getFileName(oc),
                desc: oc.abr,
                compl: ' SA: ' + ((oc.sa) ? oc.sa : ''),
                visible: true,
                element: oc
            };
        }

    }
    return rows;
}

function generateItemsForDaysView(appointments) {
    /**
     * @type {import("../../dist/gstc").Items}
     */
    const items = {};
    for (let ccindex = 0; ccindex < appointments.length; ccindex++) {
        var cc = appointments[ccindex];
        for (let index = 0; index < cc.ocorrencias.length; index++) {
            var oc = cc.ocorrencias[index];
            let rowId = GSTCID(String(oc.id));
            let id = GSTCID(String(oc.id) + '-' + String(index));

            let startDayjs = GSTC.api.date(moment(oc.cpa).toDate()).startOf('day');
            let end = GSTC.api.date(moment(oc.cpc).toDate()).endOf('day').valueOf();
            items[id] = {
                id,
                label: oc.tecnico,
                agenda: (oc.atd) ? 'Atd: ' + moment(oc.atd).format('DD/MM/YYYY') : ' [Não Agendado] ',
                progress: 100,
                style: { background: getRandomColor() },
                time: {
                    start: startDayjs.startOf('day').valueOf(),
                    end,
                },
                rowId,
                img: getDefaultImage(oc.tecnico),
                classNames: ['additional-custom-class'],
                description: 'CPA: ' + moment(oc.cpa).format('DD/MM/YYYY') + ' ' + (oc.hcpa ? oc.hcpa : '__:__') +
                    ' CPC: ' + moment(oc.cpc).format('DD/MM/YYYY') + '__:__' + (oc.hcpc ? oc.hcpc : ''),
            };
        }
    }
    return items;
}

const columns = {
    data: {
        [GSTCID('code')]: {
            id: GSTCID('code'),
            data: ({ row }) => GSTC.api.sourceID(row.code),
            width: 75,
            sortable: ({ row }) => Number(GSTC.api.sourceID(row.code)),
            header: {
                content: 'C. Custo',
            },
        },
        [GSTCID('name')]: {
            id: GSTCID('name'),
            data: 'name',
            sortable: 'name',
            expander: true,
            width: 300,
            header: {
                content: 'Unidade',
            },
        },
        [GSTCID('desc')]: {
            id: GSTCID('desc'),
            data({ row, vido }) {
                if (row.desc != '') {
                    return vido.html`<div style="text-align:center">${moment(row.desc).format('DD/MM/YYYY')}</div>`;
                }
                return '';
            },
            width: 95,
            header: {
                content: 'Abertura',
            },
        },
    },
};

const bookmarks = {};

function itemSlot(vido, props) {
    const { html, onChange, update } = vido;

    let imageSrc = '';
    let description = '';
    onChange((newProps) => {
        props = newProps;
        if (!props || !props.item) return;
        imageSrc = props.item.img;
        description = props.item.description;
        update();
    });

    return (content) =>
        html`<div
        class="item-image"
        style="background:url(${imageSrc}),transparent;flex-shrink:0;border-radius:100%;width:34px;height:34px;vertical-align: middle;background-size: 100%;margin: 4px 11px 0px 0px;"
      ></div>
      <div class="item-text">
        <div class="item-label" style="font-size:16px;margin-top:2px;color:#fffffff0;line-height:1em;">Tecnico: ${content}</div>
        <div class="item-description" style="font-size:14px;margin-top:2px;color:#fffffff0;line-height:1em;">
          ${description}
        </div>
      </div>`;
}

function rowSlot(vido, props) {
    const { html, onChange, update, api } = vido;

    let img = '';
    onChange((newProps) => {
        props = newProps;
        if (!props || !props.row) return;
        img = props.row.img;
        update();
    });

    return (content) => {
        if (!props || !props.column || !img) return content;
        return api.sourceID(props.column.id) === 'name'
            ? html`<div class="row-content-wrapper" style="display:flex">
            <div class="row-content" style="flex-grow:1">${content}</div>
                <img src="${img}" style="transparent;width:20px;height:24px;vertical-align: middle;background-size: 100%;margin: auto 10px;flex-shrink:0;">
            </div>`
            : content;
    };
}

let snapTime = true;
function snapStart({ startTime, vido }) {
    if (!snapTime) return startTime;
    const date = vido.api.time.findOrCreateMainDateAtTime(startTime.valueOf());
    return date.leftGlobalDate;
}
function snapEnd({ endTime, vido }) {
    if (!snapTime) return endTime;
    const date = vido.api.time.findOrCreateMainDateAtTime(endTime.valueOf());
    return date.rightGlobalDate;
}

function canMove(item) {
    const row = gstc.api.getRow(item.rowId);
    if (row.vacations) {
        for (const vacation of row.vacations) {
            const vacationStart = vacation.from;
            const vacationEnd = vacation.to;
            // item start time inside vacation
            if (item.time.start >= vacationStart && item.time.start <= vacationEnd) {
                return false;
            }
            // item end time inside vacation
            if (item.time.end >= vacationStart && item.time.end <= vacationEnd) {
                return false;
            }
            // vacation is between item start and end
            if (item.time.start <= vacationStart && item.time.end >= vacationEnd) {
                return false;
            }
            // item start and end time is inside vacation
            if (item.time.start >= vacationStart && item.time.end <= vacationEnd) {
                return false;
            }
        }
    }
    return true;
}

const itemMovementOptions = {
    threshold: {
        horizontal: 25,
        vertical: 25,
    },
    snapToTime: {
        start: snapStart,
        end({ endTime }) {
            return endTime;
        },
    },
    events: {
        onMove({ items }) {
            for (let i = 0, len = items.after.length; i < len; i++) {
                const item = items.after[i];
                if (!canMove(item)) return items.before;
            }
            return items.after;
        },
    },
};

const itemResizeOptions = {
    threshold: 25,
    snapToTime: {
        start: snapStart,
        end: snapEnd,
    },
    events: {
        onResize({ items }) {
            for (const item of items.after) {
                if (!canMove(item)) return items.before;
            }
            return items.after;
        },
    },
};

let hideWeekends = false;

function onLevelDates({ dates, level, format, time }) {
    if (time.period !== 'day') return dates;
    if (format.period !== time.period) return dates;
    if (!hideWeekends) return dates;
    return dates.filter((date) => date.leftGlobalDate.day() !== 0 && date.leftGlobalDate.day() !== 6);
}

function onItemClick(ev) {
    const itemElement = ev.target.closest('.gstc__chart-timeline-items-row-item');
    const itemId = itemElement.dataset.gstcid;
    const item = gstc.api.getItem(itemId);
    console.log('Item click from template', item);
}

function chartTimelineItemsRowItemTemplate({
    className,
    labelClassName,
    styleMap,
    cache,
    shouldDetach,
    cutterLeft,
    cutterRight,
    getContent,
    actions,
    slots,
    html,
    vido,
    props,
}) {
    const detach = shouldDetach || !props || !props.item;
    return cache(
        detach
            ? null
            : slots.html(
                'outer',
                html`
            <div
              class=${className}
              data-gstcid=${props.item.id}
              data-actions=${actions()}
              style=${styleMap.directive()}
              @click=${onItemClick}
            >
              ${slots.html(
                    'inner',
                    html`
                  ${cutterLeft()}
                  <div class=${labelClassName}>${slots.html('content', getContent())}</div>
                  ${cutterRight()}
                `
                )}
            </div>
          `
            )
    );
}

function myItemSlot(vido, props) {
    const { onChange } = vido;

    function onClick() {
        console.log('Item click from slot', props.item);
    }

    onChange((changedProps) => {
        // if current element is reused to display other item data just update your data so when you click you will display right alert
        props = changedProps;
    });

    // return render function
    return (content) =>
        vido.html`<div class="my-item-wrapper" @click=${onClick} style="width:100%;display:flex;overflow:hidden;pointer-events:none;">${content}</div>`;
}

function onCellCreateVacation({ time, row, vido, content }) {
    if (!row.vacations) return content;
    let isVacation = false;
    for (const vacation of row.vacations) {
        if (time.leftGlobal >= vacation.from && time.rightGlobal <= vacation.to) {
            isVacation = true;
            break;
        }
    }
    if (isVacation) {
        return vido.html`<div title="VACATION" style="height:100%;width:100%;background:#A0A0A010;"></div>${content}`;
    }
    return content;
}

function myVacationRowSlot(vido, props) {
    const { onChange, html, update, api, state } = vido;

    let vacationContent = [];
    onChange((changedProps) => {
        props = changedProps;
        if (!props || !props.row || !props.row.vacations) {
            vacationContent = [];
            return update();
        }
        const configTime = state.get('config.chart.time');
        vacationContent = [];
        for (const vacation of props.row.vacations) {
            if (vacation.to < configTime.leftGlobal || vacation.from > configTime.rightGlobal) continue; // birthday date is out of the current view
            const leftPx = api.time.getViewOffsetPxFromDates(api.time.date(vacation.from));
            const rightPx = api.time.getViewOffsetPxFromDates(api.time.date(vacation.to));
            const widthPx = rightPx - leftPx - 1;
            if (widthPx < 0) continue;
            let textAlign = 'left';
            if (widthPx <= 100) textAlign = 'center';
            vacationContent.push(
                html`<div
          style="position:absolute;left:${leftPx}px;width:${widthPx}px;height:14px;white-space: nowrap;text-overflow:ellipsis;overflow:hidden;font-size:11px;background:#A0A0A0;color:white;text-align:${textAlign};"
        >
          Vacation
        </div>`
            );
        }
        update();
    });

    return (content) => html`${vacationContent}${content}`;
}

function onCellCreateBirthday({ time, row, vido, content }) {
    if (!row.birthday) return content;
    let isBirthday = false;
    for (const birthday of row.birthday) {
        if (time.leftGlobal >= birthday.from && time.rightGlobal <= birthday.to) {
            isBirthday = true;
            break;
        }
    }
    if (isBirthday) {
        return vido.html`<div title="🎁 BIRTHDAY" style="height:100%;width:100%;font-size:18px;background:#F9B32F10;"></div>${content}`;
    }
    return content;
}

function myBirthdayRowSlot(vido, props) {
    const { onChange, html, update, api, state } = vido;

    let birthdayContent = [];
    onChange((changedProps) => {
        props = changedProps;
        if (!props || !props.row || !props.row.birthday) {
            birthdayContent = [];
            return update();
        }
        const configTime = state.get('config.chart.time');
        birthdayContent = [];
        for (const birthday of props.row.birthday) {
            if (birthday.to < configTime.leftGlobal || birthday.from > configTime.rightGlobal) continue; // birthday date is out of the current view
            const leftPx = api.time.getViewOffsetPxFromDates(api.time.date(birthday.from));
            const rightPx = api.time.getViewOffsetPxFromDates(api.time.date(birthday.to));
            const widthPx = rightPx - leftPx - 1;
            if (widthPx < 0) continue;
            let textAlign = 'left';
            if (widthPx <= 100) textAlign = 'center';
            birthdayContent.push(
                html`<div
          style="position:absolute;left:${leftPx}px;width:${widthPx}px;height:14px;white-space: nowrap;text-overflow:ellipsis;overflow:hidden;font-size:11px;background:#F9B32F;color:white;text-align:${textAlign};"
        >
          🎁 Birthday
        </div>`
            );
        }
        update();
    });

    return (content) => html`${birthdayContent}${content}`;
}

let gstc, state;

const mountGSTC = async (data) => {

    var from = GSTC.api.date(moment(data.start).format('YYYY-MM-DD')).startOf('day');
    var to = GSTC.api.date(moment(data.end).format('YYYY-MM-DD')).endOf('day');

    const config = {
        licenseKey: "====BEGIN LICENSE KEY====\nHsE0GNgbDnpL0pVsnHO/fXrzjpPD76zUEkoWejxLfXhPLuaTVckoskDFktP/XN6OnnE58807/9w/2m5cuGPUxXlAoihJ7jzUVwqV4vTzTaAfoslBmBNDwa8yT8/FQ/uoWs6qUIXqsux4rNmb4nVxyRa0lPIG9NvvAxuuhkEpNuMYgp/IHmRRPuK82eMzzGnZWpJKEUj8EitKGCLic514Aa1iQ6jlFJFHqxPshgDaf0oLV45VBrxekbKCg8d4JKjJVKoBQ9ckkO6bX5z3KEIa+SbDynriHeYPAr073QTC55o60oCwXfkdxTKugiijd5iKJhfFmaRTyN9p5jFu2rBI3g==||U2FsdGVkX19001jttUTQWmTSF6uiyRLM2vdxMTrcOm17W6BkvfQvEIoWJZT5BOa68skvDJsQYT/txpYsMEK9UfmmlyNolNUufqN2hCgEtWM=\nQaXGTdyxLkEPH8L5iB8faE4l+lgCIdxf0l/3e5P3Z2oE5EBqvjZNxMBZS8yCMIYaAt8u4HmBPKTzypAnaeGyuRrePXWjTR5GbcoM/csTO1XLAkUhuM1lICLNzTuP5MS4NYS09hbfJ+hNGynkmohs31EuHWunNKNskp/h88qryDm5ptxcuBGITfuPApERw2BIJxqSfyW7/HxA8vgiLEsIU8x6KTb1EEJpZYQRCAChAFQQumBGI8Wel/I6eAcF3ya3lnLBCFHzwnh/uLurMrRaHnDxu6M4UTlXLJ5MHrcx2K5hi7nbejcqVCvaafkxUmESP5mHIJ+tQvMLAsFicePA9A==\n====END LICENSE KEY====",
        innerHeight: 480,
        //autoInnerHeight: true,
        plugins: [
            HighlightWeekends(),
            TimelinePointer(), // timeline pointer must go first before selection, resizing and movement
            Selection({
                events: {
                    onEnd(selected) {
                        console.log('Selected', selected);
                        return selected;
                    },
                },
            }),
            ItemResizing(itemResizeOptions), // resizing must fo before movement
            ItemMovement(itemMovementOptions),
            CalendarScroll(),
            ProgressBar(),
            TimeBookmarks({ bookmarks }),
            DependencyLines({
                onLine: [
                    (line) => {
                        line.type = GSTC.api.sourceID(line.fromItem.id) === '3' ? 'smooth' : 'square';
                        return line;
                    },
                ],
            }),
            ExportImage(),
            ExportPDF(),
        ],
        list: {
            row: {
                height: 68,
            },
            rows: getRowsItems(data.rows),
            columns,
        },
        chart: {
            time: {
                from: from.valueOf(),
                to: to.valueOf(),
                start: new Date(),
                onLevelDates: [onLevelDates],
            },
            item: {
                height: 50,
                gap: {
                    top: 14,
                    //bottom: 0,
                },
            },
            items: generateItemsForDaysView(data.rows),
            grid: {
                cell: {
                    onCreate: [onCellCreateVacation, onCellCreateBirthday],
                },
            },
        },
        scroll: {
            vertical: { precise: true },
            horizontal: { precise: true },
        },
        slots: {
            'chart-timeline-items-row-item': { content: [itemSlot], inner: [myItemSlot] },
            'list-column-row': { content: [rowSlot] },
            'chart-timeline-grid-row': { content: [myBirthdayRowSlot, myVacationRowSlot] },
        },
        templates: {
            'chart-timeline-items-row-item': chartTimelineItemsRowItemTemplate,
        },
        //utcMode: true,
    };

    state = GSTC.api.stateFromConfig(config);
    var element = window.document.getElementById("gstc");
    if (!element)
        element = window.document.createElement('div');
    element.id = 'gstc';
    window.document.querySelector('#toolbox')?.after(element);
    gstc = GSTC({
        element,
        state,
    });
    //@ts-ignore
    global.state = state;
    //@ts-ignore
    global.gstc = gstc;
}

// TOOLBOX BUTTONS

// Select first two cells
function selectCells() {
    const api = gstc.api;
    const allCells = api.getGridCells();
    api.plugins.Selection.selectCells([allCells[0].id, allCells[1].id]);
    console.log(api.plugins.Selection.getSelection());
}

// scroll to first item
function scrollToFirstItem() {
    const api = gstc.api;
    const firstItem = gstc.state.get(`config.chart.items.${api.GSTCID('1')}`);
    api.scrollToTime(firstItem.time.start, false);
}

global.scrollToFirstItem = scrollToFirstItem;

function downloadImage() {
    gstc.api.plugins.ExportImage.download();
}

function downloadPdf() {
    gstc.api.plugins.ExportPDF.download('timeline.pdf');
}

let darkModeEnabled = false;
function toggleDarkMode(ev) {
    darkModeEnabled = ev.target.checked;
    const el = window.document.getElementById('gstc');
    if (darkModeEnabled) {
        el?.classList.add('gstc--dark');
        window.document.body.classList.add('gstc--dark');
    } else {
        el?.classList.remove('gstc--dark');
        window.document.body.classList.remove('gstc--dark');
    }
}

function toggleHideWeekends(ev) {
    hideWeekends = ev.target.checked;
    gstc.api.time.recalculateTime();
}

function toggleSnapTime(ev) {
    snapTime = ev.target.checked;
}

function toggleExpandTime(ev) {
    const expandTime = ev.target.checked;
    const moveOutEl = window.document.getElementById('move-out');
    if (moveOutEl && expandTime) {
        // @ts-ignore
        moveOutEl.checked = expandTime;
        toggleMoveOut({ target: moveOutEl });
    }
    state.update('config.chart.time.autoExpandTimeFromItems', expandTime);
}

function toggleMoveOut(ev) {
    const moveOut = ev.target.checked;
    const expandTimeEl = window.document.getElementById('expand-time');
    if (expandTimeEl && !moveOut) {
        // @ts-ignore
        expandTimeEl.checked = moveOut;
        toggleExpandTime({ target: expandTimeEl });
    }
    state.update('config.plugin.ItemMovement.allowItemsToGoOutsideTheArea', moveOut);
    state.update('config.plugin.ItemResizing.allowItemsToGoOutsideTheArea', moveOut);
}

function zoomChange(ev) {
    const period = ev.target.value;
    let zoom = 20;
    let from = gstc.api.time.date('2020-02-1').startOf('day').valueOf();
    let to = gstc.api.time.date('2020-03-01').endOf('month').valueOf();
    switch (period) {
        case 'hours':
            zoom = 16;
            from = gstc.api.time.date('2020-02-01').startOf('day').valueOf();
            to = gstc.api.time.date('2020-03-01').endOf('month').valueOf();
            break;
        case 'days':
            zoom = 20;
            from = gstc.api.time.date('2020-02-01').startOf('day').valueOf();
            to = gstc.api.time.date('2020-03-01').endOf('month').valueOf();
            break;
        case 'months':
            zoom = 26;
            from = gstc.api.time.date('2018-01-01').startOf('day').valueOf();
            to = gstc.api.time.date('2021-01-10').endOf('year').valueOf();
            break;
    }

    state.update('config.chart.time', (time) => {
        time.zoom = zoom;
        time.from = from;
        time.to = to;
        return time;
    });
}

function searchRows(event) {
    const copiedRows = getRowsItems();
    const search = String(event.target.value).trim();
    console.log('search', search);
    const regex = new RegExp(`[\\s\\S]?${search}[\\s\\S]?`, 'gi');
    const rowsToKeep = [];
    for (const rowId in copiedRows) {
        const row = copiedRows[rowId];
        const rowData = gstc.api.getRowData(rowId);
        if (regex.test(row.label)) {
            rowsToKeep.push(rowId);
            for (const childRowId of rowData.allChildren) {
                rowsToKeep.push(childRowId);
            }
            for (const parentRowId of rowData.parents) {
                rowsToKeep.push(parentRowId);
                if (search) copiedRows[parentRowId].expanded = true;
            }
        }
        regex.lastIndex = 0;
    }
    const uniqueRowsToKeep = [...new Set(rowsToKeep)]; // js way to get only unique row id's- we don't want duplicates here
    for (const rowId in copiedRows) {
        if (uniqueRowsToKeep.includes(rowId)) {
            copiedRows[rowId].visible = true;
        } else {
            copiedRows[rowId].visible = false;
        }
    }
    state.update('config.list.rows', (currentRows) => {
        return copiedRows;
    });
}

const historyStates = [];
global.historyStates = historyStates;

let currentStateName = '';
function saveCurrentState(stateName) {
    const items = GSTC.api.merge({}, state.get('config.chart.items'));
    historyStates.push({ name: stateName, state: items });
    currentStateName = stateName;
    updateToolBox();
}

function restoreState(stateName) {
    const historyState = historyStates.find((s) => s.name == stateName);
    currentStateName = stateName;
    const clonedState = GSTC.api.merge({}, historyState.state);
    state.update('config.chart.items', clonedState);
    updateToolBox();
}

function onRestoreStateChange(ev) {
    const name = ev.target.value;
    restoreState(name);
}

function openSaveCurrentStateDialog() {
    const stateName = prompt('Enter current state name');
    saveCurrentState(stateName);
}

function deleteSelectedItems() {
    const selectedItems = gstc.api.plugins.Selection.getSelected()['chart-timeline-items-row-item']; // cloned items
    gstc.api.plugins.Selection.selectItems([]); // clear selection
    state.update('config.plugin.Selection.lastSelecting.chart-timeline-items-row-item', []);
    state.update('config.chart.items', (items) => {
        for (const item of selectedItems) {
            delete items[item.id];
        }
        return items;
    });
}


const html = GSTC.lithtml.html;

function updateToolBox() {
    const searchBoxHTML = html`<input type="text" @input=${searchRows} placeholder="Search" />`;
    const historyStateHTML = html`<button @click="${openSaveCurrentStateDialog}">Save items</button>
    <label>Restore items:</label>
    <select @change=${onRestoreStateChange}>
      ${historyStates.map(
        (historyState) =>
            html`<option value=${historyState.name} ?selected=${historyState.name === currentStateName}>
            ${historyState.name}
          </option>`
    )}
    </select>`;

    const toolboxButtons = html` <div class="toolbox-row">
      <div class="toolbox-item"><button @click=${selectCells}>Select first cells</button></div>
      <div class="toolbox-item"><button @click=${scrollToFirstItem}>Scroll to first item</button></div>
      <div class="toolbox-item"><button @click=${downloadImage}>Download image</button></div>
      <div class="toolbox-item"><button @click=${downloadPdf}>Download PDF</button></div>
      <div class="toolbox-item">${historyStateHTML}</div>
      <div class="toolbox-item">
        <label>Zoom:</label>
        <select @change="${zoomChange}" id="zoom">
          <option value="hours">Hours</option>
          <option value="days" selected>Days</option>
          <option value="months">Months</option>
        </select>
      </div>
      <div class="toolbox-item">
        <button @click=${deleteSelectedItems}>Delete selected items</button>
      </div>
    </div>
    <div class="toolbox-row">
      <div class="toolbox-item">${searchBoxHTML}</div>
      <div class="toolbox-item">
        <input type="checkbox" id="dark-mode" @change=${toggleDarkMode} /> <label for="dark-mode">Dark mode</label>
      </div>
      <div class="toolbox-item">
        <input type="checkbox" id="snap-time" @change=${toggleSnapTime} checked />
        <label for="snap-time">Snap time (item movement)</label>
      </div>
      <div class="toolbox-item">
        <input type="checkbox" id="hide-weekends" @change=${toggleHideWeekends} />
        <label for="hide-weekends">Hide weekends</label>
      </div>
      <div class="toolbox-item">
        <input type="checkbox" id="expand-time" @change=${toggleExpandTime} />
        <label for="expand-time">Expand view when item is outside</label>
      </div>
      <div class="toolbox-item">
        <input type="checkbox" id="move-out" @change=${toggleMoveOut} checked />
        <label for="move-out">Alow items to move outside area</label>
      </div>
    </div>`;
    // @ts-ignore
    GSTC.lithtml.render(toolboxButtons, window.document.getElementById('toolbox'));
}

const gstcEl = window.document.getElementById('gstc');
gstcEl?.addEventListener('gstc-loaded', () => {
    console.log('GSTC loaded!');
    saveCurrentState('Initial');
});


const Work = ({ data, refreshAppontiments }) => {

    const callback = useCallback(async (element) => {
        if (element) {
            data = await refreshAppontiments();
            mountGSTC(data);
        }
    }, []);

    useEffect(() => {
        return () => {
        };
    });

    return (

        <Paper >
            <div className="App">
                <div id="gstc" className="gstc-wrapper" ref={callback}></div>
            </div>
        </Paper >

    );
};

export default Work;